import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_xtn_einvoice_unmatched_history_RowClass } from '../../../dbschema/index';

export class XtnEinvoiceUnmatchedHistoryContainer extends BaseContainerModel {
  bl_b2b_xtn_einvoice_unmatched_history: bl_b2b_xtn_einvoice_unmatched_history_RowClass = new bl_b2b_xtn_einvoice_unmatched_history_RowClass();
}
